import { render, staticRenderFns } from "./BottomRightTable3.vue?vue&type=template&id=59a3c9c8&"
import script from "./BottomRightTable3.vue?vue&type=script&lang=js&"
export * from "./BottomRightTable3.vue?vue&type=script&lang=js&"
import style0 from "./BottomRightTable3.vue?vue&type=style&index=0&id=59a3c9c8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports